export class AutenticacaoProvedor {
  constructor({ autenticacaoProvedorId, host, user }) {
    this.autenticacaoProvedorId = autenticacaoProvedorId;
    this.host = host;
    this.user = user;
  }
}
